import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import { useTenant } from '../components/TenantContext.jsx';

// 授權管理專職帳號（與後端 SDX500_LICENSE_ADMIN_EMAILS 預設一致；前端 gate 為 UX，
// 真權限邊界在後端 requireTecomAdmin）。要加人時兩邊都要改。
const LICENSE_ADMIN_EMAILS = ['license_admin@tecom.com'];

/**
 * 東訊授權管理頁守衛 — 2026-07-09 起只給專職帳號 license_admin@tecom.com 或 super_admin
 * （原本全部 @tecom.com；已從 admin@tecom.com 移出）。其他帳號 deep-link /sdx500 導回首頁。
 */
export function RequireTecom({ children }) {
    const { user } = useAuth();
    const { isSuperAdmin, loading } = useTenant();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    const email = (user?.email || '').toLowerCase();
    if (!(LICENSE_ADMIN_EMAILS.includes(email) || isSuperAdmin)) return <Navigate to="/" replace />;
    return children;
}
